<template>
  <!--  关键属性 -->
  <section class="key-attributes-wrap">
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="formData"
      @Refresh="Refresh"
      @search="onHandleSearch"
      @selectChange="SecondChange"
    >
      <template v-slot:right>
        <el-button @click="onHandleExport" type="warning" icon="el-icon-upload2"
          >导出</el-button
        >
        <el-button type="info" @click="addData">新增</el-button>
      </template>
    </Filtersearch>
    <!-- 列表 start -->
    <section class="content-wrap">
      <table-list
        ref="table"
        v-loading="loadingData"
        :tableData="tableData"
        @submit-form="submitForm"
        @onHandleEdit="onHandleEdit"
      ></table-list>
    </section>
    <!-- 列表 end -->

    <!-- 分页 start -->
    <!-- <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="onHandleSizeChange"
        @current-change="onHandleCurrentChange"
        :current-page="formData.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="formData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div> -->
    <!-- 分页 end -->
  <add-attribute
      ref="addAttributeRef"
      @on-change="submitForm"
      :cidType="cidType"
    ></add-attribute>
    <!-- 编辑 start -->
    <edit-config-dialog
      ref="editConfig"
      @submit-form="submitForm"
    ></edit-config-dialog>
    <!-- 编辑 end -->
  </section>
</template>
<script>
import AddAttribute from "../modules/add-attribute/index.vue";
import editConfigDialog from "./modules/editConfig/index";
import TableList from "./modules/table-list/index.vue";
import cloneDeep from "lodash/cloneDeep";
import Filtersearch from "@/components/Filtersearch.vue";
import {
  postCategoriesCustomFieldList,
  postCategoriesFirstList,
  postCategoriesSecondList,
} from "@/api/generalControl/key-attributes.js";
import { postCategoriesCustomFieldExport } from "@/api/allExport";
import { downLoadFlowBlob } from "@/utils/tools/base";

export default {
  name: "key-attributes",
  components: { editConfigDialog, TableList, Filtersearch,AddAttribute },
  data() {
    return {
      Filtersearchlist: [
        {
          type: "selectChange",
          name: "一级品类",
          // clearable: true,
          filterable: true,
          model: "first_cid",
          placeholder: "请选择一级品类",
          selectoptionname: "firstList",
          label: "name",
          value: "id",
          selectoption: [],
        },
        {
          type: "select",
          name: "二级品类",
          // clearable: true,
          filterable: true,
          model: "cid",
          placeholder: "请选择二级品类",
          label: "name",
          value: "id",
          selectoptionname: "secondCidList",
          selectoption: [],
        },
      ],
      total: 0,
      loadingData: false,
      formData: {
        first_cid: "",
        cid: "",
      },
      cidType:'',
      formDataClone: {}, // 复制数据，用于初始化
      tableData: [], //列表数据
      firstList: [], // 一级品类列表
      secondCidList: [], // 二级品类列表
      disabledExport: false,
    };
  },
  created() {
    this.formDataClone = cloneDeep(this.formData);
    if (this.$route.query.first_cid) {
      console.log(this.$route.query.first_cid, "222");
      this.formData.first_cid = Number(this.$route.query.first_cid);
      this.formData.cid = Number(this.$route.query.cid);
      this.cidType = this.$route.query.cidType;
    }
    this.initData();
  },
  methods: {
    // 一级品类 切换 请求二级品类列表
    SecondChange(e) {
      console.log(e, "e---");
      this.formData.first_cid = e;
      this.formData.cid = "";
      this.postAjaxCategoriesSecondList();
    },
    // 一级品类列表
    async postAjaxCategoriesFirstList() {
      try {
        const res = await postCategoriesFirstList();
        console.log(res, "res");
        this.firstList = res.data || [];
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "selectChange" &&
            el.selectoptionname &&
            el.selectoptionname == "firstList"
          ) {
            el.selectoption = res.data;
          }
        });
        this.formData.first_cid = this.formData.first_cid
          ? this.formData.first_cid
          : res.data[0].id;
        this.postAjaxCategoriesSecondList(true);
      } catch (error) {
        console.log(error, "postCategoriesFirstList");
      }
    },
    // 二级品类列表
    async postAjaxCategoriesSecondList(val) {
      try {
        const res = await postCategoriesSecondList({
          cid: this.formData.first_cid,
        });
        console.log(res, "res");
        this.secondCidList = res.data || [];
        this.formData.cid = this.formData.cid
          ? this.formData.cid
          : res.data.length > 0
          ? res.data[0].id
          : "";
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "secondCidList"
          ) {
            el.selectoption = res.data || [];
          }
        });
        // 刷新列表
        if (val) {
          this.postAjaxCategoriesCustomFieldList();
        }
      } catch (error) {
        console.log(error, "postCategoriesSecondList");
      }
    },
    // 新增属性
    addData() {
      if (!this.formData.first_cid || !this.formData.cid) {
        this.$message.error("请选择品类");
        return;
      }
      let oneName = "";
      let twoName = "";
      this.firstList.map((oneItem) => {
        if (oneItem.id == this.formData.first_cid) {
          oneName = oneItem.name;
        }
      });
      this.secondCidList.map((twoItem) => {
        if (twoItem.id == this.formData.cid) {
          twoName = twoItem.name;
        }
      });
      console.log(oneName, twoName, "1223");
      this.$refs.editConfig.initData("添加属性", {
        ...this.formData,
        c_name: `${oneName}-${twoName}`,
      });
    },
    /**
     * 每页条数发生改变
     */
    onHandleSizeChange(val) {
      this.formData.pageSize = val;
      this.postAjaxCategoriesCustomFieldList();
    },
    /**
     * 页码发生改变
     */
    onHandleCurrentChange(val) {
      this.formData.page = val;
      this.postAjaxCategoriesCustomFieldList();
    },
    /**
     * 查询
     */
    onHandleSearch(e) {
      this.formData = e;
      this.postAjaxCategoriesCustomFieldList();
    },
    /**
     * 初始化数据
     */
    initData() {
      this.postAjaxCategoriesFirstList();
    },
    /**
     * 列表数据
     */
    async postAjaxCategoriesCustomFieldList() {
      this.tableData = [];
      if (!this.formData.cid) {
        this.$message({
          message: "请选择二级品类！",
          type: "error",
        });
        return;
      }
      this.loadingData = true;
      try {
        const res = await postCategoriesCustomFieldList(this.formData);
        console.log(res, "eeewe");
        this.tableData = res.data;
      } catch (error) {
        console.log(error, "postCategoriesCustomFieldList");
      } finally {
        this.loadingData = false;
      }
    },
    //导出
    onHandleExport() {
      postCategoriesCustomFieldExport().then((res) => {
        console.log(res);
        downLoadFlowBlob(res, res?.filename);
      });
    },
    /**
     * 重置数据
     */
    Refresh() {
      this.postAjaxCategoriesFirstList();
    },
    /**
     * 编辑
     */
    onHandleEdit(e) {
      console.log(e, "erooiowieoiweoi");
      // this.$refs.editConfig.initData("编辑属性", e);
       this.$refs.addAttributeRef.onInitData(this.formData.cid, e);
    },
    /**
     * 刷新列表
     */
    submitForm() {
      this.postAjaxCategoriesCustomFieldList();
    },
  },
};
</script>

<style lang="scss" scoped>
.key-attributes-wrap {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  .form {
    padding: 13px 15px;
  }
  .totalWrap {
    margin-top: 10px;
    background: #ffffff;
    padding: 12px 15px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    font-size: 16px;

    .showText {
      font-size: 16px;
    }
  }
  .content-wrap {
    flex: 1;
    overflow-y: hidden;
  }
  .pagination {
    box-sizing: border-box;
    padding: 10px 20px;
  }
}
</style>
